import React, { useState } from 'react';
import { useTranslation } from '../../i18n';
import { PlayersList } from './PlayersList';
import { AppIcon } from './icons';
import '../../styles/lobby.css';

interface Player {
  id: string;
  name: string;
  score?: number;
  avatar?: string;
}

interface PlayerListSectionProps {
  players: Player[];
  variant?: 'compact' | 'detailed' | 'grid';
  showScores?: boolean;
  title?: React.ReactNode;
  containerStyle?: React.CSSProperties;
  listStyle?: React.CSSProperties;
  className?: string;
  collapsible?: boolean;
  maxVisible?: number;
}

export const PlayerListSection: React.FC<PlayerListSectionProps> = ({
  players,
  variant = 'compact',
  showScores = false,
  title,
  containerStyle,
  listStyle,
  className,
  collapsible = false,
  maxVisible = 4,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const defaultTitle = (
    <>
      <AppIcon name="people" fontSize="small" /> {t('common.players', { count: players.length })}
    </>
  );
  const displayTitle = title !== undefined ? (title === '' ? null : title) : defaultTitle;
  const hasMore = collapsible && players.length > maxVisible;
  const visiblePlayers = hasMore && !expanded ? players.slice(0, maxVisible) : players;
  const isDense = players.length > 8;

  return (
    <div
      className={`player-list-section ${collapsible ? 'player-list-section--compact' : ''} ${isDense ? 'player-list-section--dense' : ''} ${className || ''}`}
      style={containerStyle}
    >
      {displayTitle && (
        <h3 className="player-list-section-title">{displayTitle}</h3>
      )}
      {players.length === 0 ? (
        <p className="player-list-section__waiting-line">{t('gameplay.partyHost.waitingForPlayers')}</p>
      ) : (
        <>
          <PlayersList
            players={visiblePlayers}
            variant={variant}
            showScores={showScores}
            className="players-container--lobby"
            style={listStyle}
          />
          {hasMore && (
            <button
              type="button"
              className="lobby-panel-expand-btn"
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded ? t('common.showLess') : t('common.showAllPlayers', { count: players.length })}
            </button>
          )}
        </>
      )}
    </div>
  );
};
